module.exports = __webpack_public_path__ + "img/B高通5.2063b72a.png";